import React from "react";
import SpinnerHandler from "../../../hoc/SpinnerHandler/SpinnerHandler";
import useHttpSection from "../../../hooks/useHttpSection";
import moment from "moment-jalaali";
import { Link } from "react-router-dom";
import "./sectionStyle.scss";

const AquiferSection = (props) => {
  const { data, isLoading } = useHttpSection(props);
  // console.log(data);

  const AquiferTabs = {
    title: "ایستگاه هیدرومتریک",
    chart: "Chart/Hydrometric",
    values: [{ value: "نام" }, { value: "میانگین تغییر حجم" }],
    colors: ["#f3faf9", "#f9f3fa"],
    widths: ["160px", "200px"],
    totalWidth: 850,
    items: {
      name: 3,
      code: 2,
      // river: 0,
      river_eng: 0,
      latest_update: {
        discharge: 1,
      },
    },
  };
  const handleDate = (item) => {
    if (item) {
      if (item.date) {
        return moment(item.date).format("jYYYY/jMM/jDD");
      } else {
        return "";
      }
    } else {
      return "";
    }
  };
  return (
    <SpinnerHandler isLoading={isLoading}>
      <div className="topHeaderContainer">
        <ul className="listTab">
          {AquiferTabs.values.map((e, i) => (
            <li
              style={{
                backgroundColor: AquiferTabs.colors[i],
                width: AquiferTabs.widths[i],
                fontWeight: "bolder",
                fontSize: 14,
              }}
              key={e.value}
            >
              {e.value}
            </li>
          ))}
        </ul>
        <div className="line topline">
          <div></div>
        </div>
      </div>
      {data.map((item) => (
        <div key={item.id} className="rowContainer">
          <div className="RowAquiferContainer">
            <div style={{ display: "flex" }}>
              <div className="item1">
                <p>{item.study_scope}</p>
              </div>
              <div className="item2">
                <p>
                  {item.latest_update && item.latest_update.volume_change_mean}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update &&
                  (item.latest_update.volume_change_mean === 0 ||
                    item.latest_update.volume_change_mean)
                    ? handleDate(item.latest_update)
                    : ""}
                </p>
              </div>
            </div>
            <div className="buttonBox">
              <Link
                className="link"
                to={{
                  pathname: "/Chart/Aquifer",
                  state: { name:item.study_scope, id: item.id },
                }}
              >
                <div className="buttonFullData">اطلاعات کامل</div>
              </Link>
            </div>
          </div>

          <div className="line">
            <div></div>
          </div>
        </div>
      ))}
      {!data.length && !isLoading && (
        <div className="noItemContainer">
          <p>هیچ موردی یافت نشد</p>
        </div>
      )}
    </SpinnerHandler>
  );
};

export default AquiferSection;
